import styled from 'styled-components';
import { CarNumberStyled } from '../CarNumberStyled';
import { rem } from 'polished';
export const CarNumberStyledOV = styled(CarNumberStyled)`
    color: ${({ theme }) => theme.colors.grey28};
    font-size: ${rem('12px')};
`;
